const imageWithCrop = {
  image: {
    blobImage: true,
  },
};

export { imageWithCrop };
